import { Component, ComponentFactoryResolver, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CieUtilsModalManagerService, CustomComponent } from '@cakeiteasy/web-utils';
import { UiContextService } from '@cakeiteasy/web-utils';
import { ContactUsModalComponent } from '@modals/contact-us-modal/contact-us-modal.component';
import { HowItWorksModalComponent } from '@modals/how-it-works-modal/how-it-works-modal.component';
import { HeaderProviderService } from '@entire/services/header-provider.service';
import { UserAuthModalComponent } from '@modals/user-auth-modal/user-auth-modal.component';
import { MODAL_CLOSE_ACTIONS } from '@shared/constants';
import { IUser, UserManager, AUTH_FORMS } from '@cakeiteasy/order-process';
import { APP_ROUTES } from '@entire/route-names';
import { AnalyticTracker } from '@analytic/services/analytic-tracker.service';

@Component({
  standalone: false,
  selector: 'header-mobile-menu',
  templateUrl: './header-mobile-menu.component.html',
  styleUrls: ['./header-mobile-menu.component.scss']
})
export class HeaderMobileMenuComponent extends CustomComponent implements OnInit {
  @Input() user: IUser;
  @Input() giftCardsEnabled: boolean;

  public isOpen: boolean = false;

  constructor(private _componentResolver: ComponentFactoryResolver,
              private _modalManager: CieUtilsModalManagerService,
              private _uiContext: UiContextService,
              private _headerProvider: HeaderProviderService,
              private _userManager: UserManager,
              private _router: Router,
              private _analyticTracker: AnalyticTracker) {
    super();
  }

  ngOnInit() {
    this.addSubscriber(this._headerProvider.isMobileMenuOpen$.subscribe((isOpen) => {
      this.isOpen = isOpen;
    }));

    this._router.events.subscribe(() => {
      this._headerProvider.isMobileMenuOpen$.next(false);
    });
  }

  public logout() {
    this._analyticTracker.trackLogout();
    this._userManager.logout();
  }

  public goToMyAccount() {
    let path = ['/', 'profile'];
    if (!this._uiContext.isMobile()) {
      path.push('my-account');
    }

    return this._router.navigate(path);
  }

  public goToGiftCards() {
    this._router.navigate(['/', APP_ROUTES.GIFT_CARDS]);
  }

  public showLogin() {
    this._modalManager
      .show(UserAuthModalComponent, this._componentResolver, {}, { windowClass: 'modal-simple md' });
  }

  public showContactUs() {
    this._modalManager
      .show(ContactUsModalComponent, this._componentResolver, {},
        { windowClass: 'modal-simple lg' });
  }

  public showHowItWorks() {
    this._modalManager
      .show(HowItWorksModalComponent, this._componentResolver, {}, { windowClass: 'modal-xl-4 how-it-works-modal' })
      .then((result) => result === MODAL_CLOSE_ACTIONS.OPEN_CONTACT_US ? this.showContactUs() : null);
  }
}
